import { api_configuration } from "../../common";
import api_app = api_configuration.libraries.gui_definition_lib.libraries.model_lib.types.application.alan_api;
import { getGuiText, getGuiNumber, getGuiStategroup } from "../guiModel";

const stickyvalues: Record<string, string | number> = {};
const isStickyProperties: Record<string, boolean> = {};

export function getStickyValue(property: api_app.Ctext__type__property): string | undefined;
export function getStickyValue(property: api_app.Cnumber__type__property): number | undefined;
export function getStickyValue(property: api_app.Cstate_group): string | undefined;
export function getStickyValue(
	property: api_app.Cstate_group | api_app.Ctext__type__property | api_app.Cnumber__type__property
): string | number | undefined {
	return stickyvalues[property.path];
}

function setStickyValue(property: api_app.Ctext__type__property, value: string): void;
function setStickyValue(property: api_app.Cnumber__type__property, value: number): void;
function setStickyValue(property: api_app.Cstate_group, value: string): void;
function setStickyValue(
	property: api_app.Cstate_group | api_app.Ctext__type__property | api_app.Cnumber__type__property,
	value: string | number
): void {
	stickyvalues[property.path] = value;
}

function isSticky(
	property: api_app.Cstate_group | api_app.Ctext__type__property | api_app.Cnumber__type__property
): boolean {
	return isStickyProperties[property.path];
}

export function setStickyTextValue(text_definition: api_app.Ctext__type__property, value: string): void {
	const gui_text = getGuiText(text_definition);
	if (!gui_text) return;
	let is_sticky = isSticky(text_definition);
	if (is_sticky === undefined) {
		let new_sticky: boolean;
		switch (gui_text.properties.default_.state.name) {
			case "no": {
				new_sticky = false;
				break;
			}
			case "yes": {
				const $ = gui_text.properties.default_.state.node;
				new_sticky = false;
				switch ($.properties.source.state.name) {
					case "auto select only candidate":
						break;
					case "current user":
						break;
					case "expression": {
						const expression = $.properties.source.state.node;
						new_sticky = analyseDefaultForStickyness(expression.inferences.text_with_default().properties.default_);
						break;
					}
					case "guid":
						break;
					case "select source":
						break;
					default:
						unexpectedState($.properties.source.state);
				}
				break;
			}
			default:
				unexpectedState(gui_text.properties.default_.state);
		}
		is_sticky = new_sticky;
	}
	if (is_sticky) {
		setStickyValue(text_definition, value);
	}
}
export function setStickyNumberValue(number_definition: api_app.Cnumber__type__property, value: number): void {
	const gui_number = getGuiNumber(number_definition);
	if (!gui_number) return;
	let is_sticky = isSticky(number_definition);
	if (is_sticky === undefined) {
		let new_sticky: boolean;
		switch (gui_number.properties.default_.state.name) {
			case "no": {
				new_sticky = false;
				break;
			}
			case "yes": {
				const $ = gui_number.properties.default_.state.node;
				new_sticky = false;
				switch ($.properties.value.state.name) {
					case "now":
						break;
					case "one":
						break;
					case "zero":
						break;
					case "today":
						break;
					case "expression": {
						const expression = $.properties.value.state.node;
						new_sticky = analyseDefaultForStickyness(expression.inferences.model_expression().properties.default_);
						break;
					}
					default:
						unexpectedState($.properties.value.state);
				}
				break;
			}
			default:
				unexpectedState(gui_number.properties.default_.state);
		}
		is_sticky = new_sticky;
	}
	if (is_sticky) {
		setStickyValue(number_definition, value);
	}
}
export function setStickyStateGroupValue(stategroup_definition: api_app.Cstate_group, value: string): void {
	const gui_stategroup = getGuiStategroup(stategroup_definition);
	if (!gui_stategroup) return;
	let is_sticky = isSticky(stategroup_definition);
	if (is_sticky === undefined) {
		let new_sticky: boolean;
		switch (gui_stategroup.properties.default_.state.name) {
			case "no": {
				new_sticky = false;
				break;
			}
			case "yes": {
				const $ = gui_stategroup.properties.default_.state.node;
				new_sticky = false;
				switch ($.properties.source.state.name) {
					case "state":
						break;
					case "state switch": {
						const expression = $.properties.source.state.node;
						new_sticky = analyseDefaultForStickyness(expression.inferences.model_state_switch().properties.default_);
						break;
					}
					default:
						unexpectedState($.properties.source.state);
				}
				break;
			}
			default:
				unexpectedState(gui_stategroup.properties.default_.state);
		}
		is_sticky = new_sticky;
	}
	if (is_sticky) {
		setStickyValue(stategroup_definition, value);
	}
}

function analyseDefaultForStickyness(default_: api_app.Cui_scalar_default): boolean {
	if (analyseExpressionForStickyness(default_.properties.expression)) {
		return true;
	}
	switch (default_.properties.has_fallback.state.name) {
		case "no": {
			return false;
		}
		case "yes": {
			const $ = default_.properties.has_fallback.state.node;
			return analyseDefaultForStickyness($.properties.fallback);
		}
		default:
			unexpectedState(default_.properties.has_fallback.state);
	}
}

function analyseExpressionForStickyness(expression: api_app.Cui_expression): boolean {
	switch (expression.properties.operation.state.name) {
		case "entry": {
			return false;
		}
		case "entry list": {
			return false;
		}
		case "execute operation": {
			return false;
		}
		case "ignore": {
			return false;
		}
		case "node switch": {
			const $ = expression.properties.operation.state.node;
			return (
				analyseExpressionForStickyness($.properties.cases.properties.node_case.properties.expression) ||
				analyseExpressionForStickyness($.properties.cases.properties.none_case.properties.expression)
			);
		}
		case "produce value": {
			const $ = expression.properties.operation.state.node;
			switch ($.properties.value.state.name) {
				case "object": {
					return false;
				}
				case "scalar": {
					const scalar = $.properties.value.state.node;
					return analyseScalarValueExpression(scalar.properties.expression);
				}
				case "state": {
					return false;
				}
				default:
					return unexpectedState($.properties.value.state);
			}
		}
		case "state switch": {
			const $ = expression.properties.operation.state.node;
			for (const state of $.properties.states) {
				if (analyseExpressionForStickyness(state[1].properties.expression)) {
					return true;
				}
			}
			return false;
		}
		case "update properties": {
			return false;
		}
		case "walk": {
			const $ = expression.properties.operation.state.node;
			return analyseExpressionForStickyness($.properties.expression);
		}
		default:
			unexpectedState(expression.properties.operation.state);
	}
}

function analyseScalarValueExpression(expression: api_app.Cui_scalar_value_expression): boolean {
	switch (expression.properties.type.state.name) {
		case "dynamic": {
			return false;
		}
		case "number": {
			return false;
		}
		case "state": {
			return false;
		}
		case "sticky": {
			return true;
		}
		case "style": {
			return false;
		}
		case "text": {
			return false;
		}
		default:
			unexpectedState(expression.properties.type.state);
	}
}
